module.exports = __webpack_public_path__ + "img/atlas-mutuel.5825faee.jpg";